import { iGetClientOptionBalancesQueryResponse } from "../interfaces/chrInterfaces";
import { cBigNumber } from "./BigNumber";
import { iBalance, iOption, zeroBN } from "../interfaces/interfaces";
import { store } from "../store/store";


export class cChromiaBalance implements iBalance{
	fullBalance: cBigNumber;
	exerciseBalance: cBigNumber;
	lockedBalance: cBigNumber;
	createdBalance: cBigNumber;
	borrowBalance: cBigNumber;

	availableBalance: cBigNumber;
	isShowedYourDesc: boolean;
	isShowedCreatedDesc: boolean;
	fullExButtonShowed = false;      // basic
	cancelExButtonShowed = false;    // basic
	finalizeExButtonShowed = false;
	uncreateButtonShowed = false;
	withdrawButtonShowed = false;
	borrowButtonShowed = false;
	opt: iOption;
	isExpired: boolean;

	optId: string | undefined;     // chromia field
	isShowedChrDesc: boolean;


	constructor (responseBalance: iGetClientOptionBalancesQueryResponse, option: iOption){
		this.fullBalance = new cBigNumber(responseBalance.balance);
		this.exerciseBalance = new cBigNumber(responseBalance.exercised);
		this.lockedBalance = new cBigNumber(responseBalance.locked);
		this.createdBalance = new cBigNumber(responseBalance.created);
		this.borrowBalance = new cBigNumber('0');

		const { systemTimestamp } = store.getState().app;
		const { params } = store.getState().chromia;
		
		if (systemTimestamp === null || !params) throw new Error(
			'Error code: 5_0' +
			(systemTimestamp?'' : '\ntime: -') +
			(params? '' : '\nparams: -')
		);

		const autoexerciseTime = params.autoexerciseTime;

		// available_balance
		this.availableBalance = this.fullBalance.sub(this.exerciseBalance).sub(this.lockedBalance);

		// is showed for your_options_table
		const isAutoexercised = option.maturityPrice.gt(zeroBN)
			? option.optionType
				? option.maturityPrice.gt(option.strike.initial)
				: option.maturityPrice.lt(option.strike.initial)
			: false
		;
		const hasBalance = option.maturityTime + autoexerciseTime > systemTimestamp && this.fullBalance.gt(zeroBN);
		const hasExBalance = option.maturityTime + autoexerciseTime < systemTimestamp && this.exerciseBalance.gt(zeroBN);
		this.isShowedYourDesc = isAutoexercised || (hasBalance && option.maturityTime + autoexerciseTime > systemTimestamp) || hasExBalance;

		// is showed for created_options_table
		this.isShowedCreatedDesc = this.createdBalance.gt(zeroBN);

		this.isExpired = systemTimestamp > option.maturityTime;

		// buttons
		if (systemTimestamp > option.maturityTime + autoexerciseTime){  // option has expired and autoexercise time has passed
			if (this.exerciseBalance.gt(zeroBN) || isAutoexercised){
				this.finalizeExButtonShowed = true;
			}
			if (this.createdBalance.gt(zeroBN)){
				this.withdrawButtonShowed = true;
			}
		}
		if (!this.isExpired) {    // option not expired
			if (this.createdBalance.gt(zeroBN) && this.availableBalance.gt(zeroBN)){
				this.uncreateButtonShowed = true;
			}
			if (this.availableBalance.gt(zeroBN)){
				this.fullExButtonShowed = true;
			}
			if (this.exerciseBalance.gt(zeroBN)){
				this.cancelExButtonShowed = true;
			}
			// if ((+response_balance.borrow_balance > 0 || +this.available_balance > 0) && opt.call_type){  // available only for calls
				this.borrowButtonShowed = true;
			// }
		}

		// opt
		this.opt = option;

		// chromia
		this.optId = responseBalance.opt.toString('hex');

		this.isShowedChrDesc = systemTimestamp < option.maturityTime
			? true  // not expired
			: this.availableBalance.gt(zeroBN)
			// : +this.available_balance > 0 || +this.exercise_balance > 0 || +this.created_balance > 0
		;
	}
}